import React, { useState } from "react";
import { useSelector } from "react-redux";
import { AmountText, Max, InputCurrency, TextAlign, InputDiv } from "./style";

function InputAmount(props) {
  const [maxbalance, setBalanceMax] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const { projectNamePoolName } = useSelector((state) => state.global);

  const getMaxAmount = (value) => {
    setBalanceMax(true);
    props?.onChange && props?.onChange(parseFloat(value));
  };

  const onChangeHandler = (event) => {
    if (maxbalance === true) {
      setBalanceMax(false);
    }
    const value = event.target.value;
    setInputValue(parseFloat(value));
    props?.onChange && props?.onChange(parseFloat(value));
  };

  return (
    <div>
      <AmountText>
        <p>{props?.amount === undefined || NaN || "" ? "" : props?.amount}</p>
        <TextAlign style={{ minWidth: "187px" }}>
          <p>
            {props?.balance === undefined || NaN || "" ? "" : props?.balance}
          </p>
        </TextAlign>
      </AmountText>
      <InputDiv>
        <InputCurrency
          type="number"
          name="input"
          onChange={onChangeHandler}
          value={
            maxbalance
              ? parseFloat(props?.balance?.toString()?.split(":")[1])
              : inputValue
          }
        ></InputCurrency>
        <Max
          onClick={() =>
            getMaxAmount(parseFloat(props?.balance?.toString()?.split(":")[1]))
          }
        >
          MAX
        </Max>
      </InputDiv>
      <AmountText>
        <p>{props?.weight === undefined ? "" : props?.weight}</p>
        <TextAlign>
          <p>
            {props?.apy === undefined
              ? ""
              : props?.apy === "Est. APY: Infinity"
              ? "EST. APY: " + projectNamePoolName?.pool_initial_apy + "%"
              : props?.apy}
          </p>
        </TextAlign>
      </AmountText>
    </div>
  );
}

export default InputAmount;
